import { triggerTimeoutUtils } from "./time/timeout/ITriggerTimeout.inft";
import { triggerWhenActivityInUtils } from "./app/when-activity-in/ITriggerWhenActivityIn";
export function initTriggers(){
    triggerTimeoutUtils.init()
    triggerWhenActivityInUtils.init()
}